var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBlueChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 14.9999C7.43427 15 7.36919 14.9872 7.30845 14.9621C7.24771 14.9371 7.1925 14.9003 7.14598 14.8539L0.145978 7.8539C0.0994147 7.80745 0.0624717 7.75228 0.0372653 7.69153C0.0120589 7.63079 -0.000915527 7.56567 -0.000915527 7.4999C-0.000915527 7.43413 0.0120589 7.36901 0.0372653 7.30827C0.0624717 7.24752 0.0994147 7.19234 0.145978 7.1459L7.14598 0.145899C7.23986 0.0520124 7.3672 -0.000732423 7.49998 -0.000732422C7.63275 -0.000732421 7.76009 0.0520124 7.85398 0.145899C7.94787 0.239786 8.00061 0.367123 8.00061 0.499899C8.00061 0.632675 7.94787 0.760013 7.85398 0.853899L1.20698 7.4999L7.85398 14.1459C7.92409 14.2158 7.97185 14.305 7.99122 14.4021C8.01058 14.4992 8.00068 14.5999 7.96276 14.6914C7.92485 14.7828 7.86062 14.861 7.77823 14.9159C7.69584 14.9708 7.599 15.0001 7.49998 14.9999Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlueChevron);
export default __webpack_public_path__ + "static/media/left-blue-chevron.76020893fc25c385323972339f5fc6df.svg";
export { ForwardRef as ReactComponent };